/**
 * Created by pskwira on 24.04.2018.
 */

define(['jquery', 'lodash', 'eventEmitter/EventEmitter'], function($, _, EventEmitter){

    var productSearchConfig = {
        pdfSearchWrapper: ".pdf__search",
        itemNumberField: "#pdfProductSearchNumber",
        searchButton: "#productSearch",
        searchResultsWrapper: ".search-results",
        searchResultsExist: ".results-exist",
        searchResultsEmpty: ".results-empty"
    }

    function ProductSearch(){

        var _this = this;

        $(document).on({
            click: function (e) {
                if (_this.$input.val() != '' && !_this.clicked) {
                    _this.clicked = true;
                    _this.search();
                }
            }
        }, '#productSearch');

    }

    ProductSearch.prototype = _.clone(EventEmitter.prototype);

    ProductSearch.prototype.init = function(){

        var _this = this;

        this.$searchWrapper = $(productSearchConfig.pdfSearchWrapper);
        this.$input = $(productSearchConfig.itemNumberField);
        this.$submit = $(productSearchConfig.searchButton);
        this.$resultsWrapper = $(productSearchConfig.searchResultsWrapper);
        this.$resultsAny = $(productSearchConfig.searchResultsExist);
        this.$resultsEmpty = $(productSearchConfig.searchResultsEmpty);
        this.clicked = false;

    };

    ProductSearch.prototype.search = function() {

        var _this = this;

        $.ajax({
            type: "GET",
            url: '/product/search/' + _this.$input.val() + '?lang='+$(_this.$submit).attr('data-page-lang')
        }).done(function( data ) {

            _this.$resultsWrapper.hide();
            _this.$resultsEmpty.hide();
            _this.$resultsAny.find('.title').text('');
            _this.$resultsAny.find('a').attr('href', '');

            if ( data.status == 1) {
                if ( data.response == 0 ) {
                    _this.$resultsWrapper.show();
                    _this.$resultsEmpty.show();
                } else {
                    _this.$resultsAny.find('.title').text(data.response.title);
                    _this.$resultsAny.find('a').attr('href', data.response.link);
                    _this.$resultsWrapper.show();
                    _this.$resultsAny.show();
                }

                _this.clicked = false;
            }
        });

    };

    return ProductSearch;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/productSearch.js